import { render } from "./TimesheetBody.vue?vue&type=template&id=ff636ffe"
import script from "./TimesheetBody.vue?vue&type=script&lang=js"
export * from "./TimesheetBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__